<script setup lang="ts">
import { ref } from 'vue'

import NavigationAside from './NavigationAside.vue'
import NavigationBar from './NavigationBar.vue'
import NavigationMenu from './NavigationMenu.vue'

const isOpen = ref(false)
const openAside = ref(false)
</script>

<template>
  <nav>
    <NavigationBar v-model="isOpen" v-model:open-aside="openAside" />
    <NavigationMenu v-model="isOpen" />
    <NavigationAside v-model="openAside" />
  </nav>
</template>

<style lang="scss" scoped></style>
